var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3186,
    cy: 30.0301,
    r: 25.001,
    transform: "rotate(-12.0831 30.3186 30.0301)",
    fill: "#9F9AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 40.4868C37.2574 40.4868 42.2942 35.4501 42.2942 29.2368C42.2942 23.0236 37.2574 17.9868 31.0442 17.9868C24.831 17.9868 19.7942 23.0236 19.7942 29.2368C19.7942 35.4501 24.831 40.4868 31.0442 40.4868Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 21.7368L31.0442 29.2368",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3442 34.5368L31.0442 29.2368",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphClockIcon);
export default __webpack_public_path__ + "static/media/graph-clock-icon.f0f2d9dd35396cc1667ed42ddfe42e39.svg";
export { ForwardRef as ReactComponent };